{
  "currentClone": {
    "detail": {},
    "id": {},
    "meta": {
      "pair": {
        "menu": {
          "edit": {},
          "remove": {}
        },
        "name": {},
        "value": {}
      },
      "toolbar": {
        "create": {}
      }
    },
    "toolbar": {
      "move": {},
      "ban": {},
      "dropdown": {
        "clear": {}
      }
    },
    "tabs": {
      "detail": {},
      "meta": {}
    }
  },
  "currentFenceDevice": {
    "id": {}
  },
  "currentGroup": {
    "detail": {},
    "id": {},
    "meta": {
      "pair": {
        "menu": {
          "edit": {},
          "remove": {}
        },
        "name": {},
        "value": {}
      },
      "toolbar": {
        "create": {}
      }
    },
    "tabs": {
      "detail": {},
      "meta": {}
    },
    "toolbar": {
      "clone": {},
      "unclone": {},
      "move": {},
      "dropdown": {
        "ban": {},
        "clear": {}
      }
    }
  },
  "currentPrimitive": {
    "attributes": {},
    "detail": {
      "pcmkAgent": {}
    },
    "id": {},
    "meta": {
      "pair": {
        "menu": {
          "edit": {},
          "remove": {}
        },
        "name": {},
        "value": {}
      },
      "toolbar": {
        "create": {}
      }
    },
    "tabs": {
      "attributes": {},
      "detail": {},
      "meta": {},
      "utilization": {}
    },
    "toolbar": {
      "disable": {},
      "dropdown": {
        "changeGroup": {},
        "cleanup": {},
        "clone": {},
        "delete": {},
        "move": {},
        "ban": {},
        "clear": {},
        "refresh": {},
        "unclone": {}
      },
      "enable": {},
      "manage": {},
      "unmanage": {}
    },
    "utilization": {
      "pair": {
        "menu": {
          "edit": {},
          "remove": {}
        },
        "name": {},
        "value": {}
      },
      "toolbar": {
        "create": {}
      }
    }
  },
  "tree": {
    "clone": {
      "id": {},
      "status": {},
      "type": {}
    },
    "group": {
      "id": {},
      "status": {},
      "type": {}
    },
    "primitive": {
      "id": {},
      "status": {},
      "type": {}
    }
  },
  "empty": {},
  "stopped": {}
}
